import { adminRoutes } from './admin.routing'
import { AdminComponent } from './admin.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'

@NgModule({
  declarations: [AdminComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(adminRoutes, { scrollPositionRestoration: 'top' }),
    HttpClientModule,
    SharedModule,
  ],
  exports: [AdminComponent],
})
export class AdminModule {}
